import React from 'react';
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker from "react-datepicker";
import Sidebar from "../../../../components/Sidebar";
import PageHeader from "../../../../components/PageHeader";
import TableHeader from "../../../../components/TableHeader";
import Pagination from "../../../../components/Pagination";
import ModalDeleteEmail from "../../../../components/Modal/admin/modalDeleteEmail";
import ModalReSendEmail from "../../../../components/Modal/admin/modalResendEmail"

import EmailHistoryApi from "../../../../services/ob-core/email-history";
import SecureCustomerApi from "../../../../services/ob-user/secure-customer";
import EmailTypeApi from "../../../../services/ob-core/email-type";

class ErrorEmailManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showDelete: false,
            pageNumber: 0,
            pageSize: 10,
            totalItem: null,
            itemSelected: {},
            listData: [],
            sort: "id",
            descending: 'DESC',
            mailType: '',
            status: null,
            startDate: '',
            endDate: '',
            startDate_temp: null,
            endDate_temp: null,
            showLoading: false,
            showResend: false,
            header: [
                {
                    id: 'index',
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'subject',
                    name: "Chủ đề",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'mailType',
                    name: "Loại",
                    style: {textAlign: "center"},
                    sort: false,
                },
                // {
                //     id: 'customerId',
                //     name: "Người nhận",
                //     style: {textAlign: "center"},
                //     sort: false,
                // },
                {
                    id: 'email',
                    name: "Email",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'date',
                    name: "Thời gian",
                    style: {textAlign: "center", minWidth: 80},
                    sort: false,
                },
                {
                    id: 'status',
                    name: "Trạng thái",
                    style: {textAlign: "center", minWidth: 80},
                    sort: false,
                },
                {
                    id: 'action',
                    name: "Thao tác",
                    style: {textAlign: "center", minWidth: 80},
                    sort: false,
                },
            ],
        }
    }

    componentWillMount() {
        this.setState({showLoading: true}, () => {
            this.getListType()
            this.getData()
        })
    }

    getListType = () => {
        EmailTypeApi.getAll(res => {
            if (res.success) {
                this.setState({type: res.data, showLoading: false})
            }
        })
    }

    getData = () => {
        let {pageNumber, pageSize, sort, startDate, endDate, descending, mailType, status} = this.state

        let payload = {
            pageNumber: pageNumber,
            pageSize: pageSize,
            // sort: sort,
            // descending: descending,
            mailType: mailType,
            status: status,
            startDate: startDate,
            endDate: endDate,
        }
        if (mailType === '') delete payload.mailType;
        if (status === null || status === '') delete payload.status;
        EmailHistoryApi.getListErrorEmail(payload, res => {
            if (res.success) {
                this.setState({
                    listData: res.data.content,
                    totalItem: res.data.totalElements,
                    showLoading: false,
                })
            } else {
                toast.error("Đã có lỗi xảy ra, vui lòng tải lại trang!")
            }
        })
    }

    getListCustomerByIds = () => {
        let {listCustomerId, listData} = this.state;
        let payload = {
            ids: listCustomerId
        };
        SecureCustomerApi.getNamesByListId(payload, res => {
            if (res.success) {
                let data = res.data;
                listData.map(item => {
                    let filter = data.filter(x => x.id == item.customerId);
                    item.customerName = filter[0]?.fullName;
                    item.customerPhone = filter[0]?.phone;
                });
                this.setState({
                    listData
                });
            } else {

            }
        });
    }

    onSearch = () => {
        let {startDate_temp, endDate_temp} = this.state;
        this.setState({
            startDate: startDate_temp,
            endDate: endDate_temp,
            pageNumber: 0
        }, () => this.getData())
    }

    onRefresh = () => {
        this.setState(
            {
                sort: "id",
                descending: 'DESC',
                mailType: '',
                status: '',
                startDate_temp: null,
                endDate_temp: null,
                pageNumber: 0
            },
            () => this.onSearch()
        );
    }

    handleChangePage = (page) => {
        this.setState({
                pageNumber: page - 1,
            }, () => {
                this.getData()
            }
        );
    }

    renderType = (t) => {
        let {type} = this.state;
        return type.filter(item => item.type === t)[0]?.name
    }

    render() {
        let {pageNumber, pageSize, totalItem} = this.state;
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="error-email-management" parentClass="email-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className='pt-3 mb-4'>
                                    <PageHeader routerEnable={true} title="Quản lý Email"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-6 pl-0">
                                                <label className="label-item">Từ ngày</label>
                                                <DatePicker
                                                    className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none"
                                                    placeholderText="Từ ngày"
                                                    selected={this.state.startDate_temp === null ? null : new Date(this.state.startDate_temp)}
                                                    maxDate={new Date()}
                                                    minDate={new Date('2000/01/01')}
                                                    dateFormat="dd-MM-yyyy"
                                                    isClearable={this.state.startDate_temp !== null}
                                                    // selectsStart
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={(date) => {
                                                        this.setState({
                                                            startDate_temp: date === null ? null : moment(date).format("YYYY-MM-DD"),
                                                        })
                                                    }}
                                                    startDate={new Date(this.state.startDate_temp)}
                                                    endDate={new Date(this.state.endDate_temp)}
                                                />
                                            </div>
                                            <div className="col-6 pr-0">
                                                <label className="label-item">Đến ngày</label>
                                                <DatePicker
                                                    className="w-auto3 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none"
                                                    placeholderText="Đến ngày"
                                                    selected={this.state.endDate_temp === null ? "" : new Date(this.state.endDate_temp)}
                                                    selectsEnd
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    disabled={this.state.startDate_temp === null}
                                                    isClearable={this.state.endDate_temp !== null}
                                                    dateFormat="dd-MM-yyyy"
                                                    onChange={(date) => {
                                                        this.setState({endDate_temp: date === null ? null : moment(date).format("YYYY-MM-DD")})
                                                    }}
                                                    startDate={new Date(this.state.startDate_temp)}
                                                    endDate={new Date(this.state.endDate_temp)}
                                                    maxDate={new Date()}
                                                    minDate={this.state.startDate_temp === null ? new Date(this.state.startDate_temp) : new Date('2000/01/01')}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6 pl-0">
                                                <label className="label-item">Loại Mail</label>
                                                <select
                                                    value={this.state.mailType}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            mailType: e.target.value
                                                        })
                                                    }}
                                                    className="form-control kt-input pd-4-input shadow-none">
                                                    <option value=''>Tất cả</option>
                                                    {this.state.type?.map(item => (
                                                        <option value={item.type}>{item.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-6 pr-0">
                                                <label className="label-item">Trạng thái</label>
                                                <select
                                                    value={this.state.status}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            status: e.target.value
                                                        })
                                                    }}
                                                    className="form-control kt-input pd-4-input shadow-none">
                                                    <option value=''>Tất cả</option>
                                                    <option value={true}>Thành công</option>
                                                    <option value={false}>Lỗi</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div
                                            className='mt-2 col-xs-12 col-sm-12 col-md-6 align-text-bottom pl-0  button-filter-wp'>
                                            <div className="button-filter">
                                                <button
                                                    type="button"
                                                    className="border-1-s mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none"
                                                    onClick={() =>
                                                        this.onSearch()
                                                    }
                                                >
                                                    Tìm kiếm
                                                </button>
                                                <button type="button"
                                                        className="border-1-s pr-2 mr-2 type-button-fix btn btn-light btn-sm shadow-none"
                                                        onClick={() => this.onRefresh()}
                                                >
                                                    Refresh
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-wrapper">
                                    <table className="table table-striped table-data table-bordered">
                                        <thead>
                                        <TableHeader header={this.state.header} clickSort={(data) => {
                                            console.log(data);
                                            let a = "";
                                            let descend = "";
                                            if (data.sortAsc == null) {
                                                // a = "id=asc";
                                                a = "id";
                                                descend = 'DESC'
                                            } else {
                                                a = data.sortId;
                                                descend = data.sortAsc ? 'ASC' : 'DESC'
                                            }
                                            this.setState(
                                                {
                                                    sort: a,
                                                    descending: descend
                                                }, () => this.onSearch())
                                        }}/>
                                        </thead>
                                        {!this.state.listData || this.state.listData.length === 0
                                            ? <tbody>
                                            <tr>
                                                <td colSpan={8}>
                                                    <div className='text-center'>Không có dữ liệu</div>
                                                </td>
                                            </tr>
                                            </tbody>
                                            : <tbody>
                                            {this.state.listData.map((row, index) => (
                                                <tr key={row.id} style={{height: 50}}>
                                                    <td style={{textAlign: 'center'}}>{pageNumber * pageSize + index + 1}</td>
                                                    <td style={{textAlign: 'left',}}>
                                                        {row.subject || 'Chưa có dữ liệu'}
                                                    </td>
                                                    <td style={{textAlign: 'center',}}>
                                                        {this.renderType(row.mailType) || 'Chưa có dữ liệu'}
                                                    </td>
                                                    {/*<td style={{textAlign: 'left',}}>*/}
                                                    {/*    {row.toOne || 'Chưa có dữ liệu'}*/}
                                                    {/*</td>*/}
                                                    <td style={{textAlign: 'left'}}>
                                                        {row.toOne || 'Chưa có dữ liệu'}
                                                    </td>
                                                    <td style={{textAlign: 'center'}}>
                                                        {moment(row.cmnCreatedAt).format("DD-MM-YYYY HH:mm")}
                                                    </td>
                                                    <td style={{textAlign: 'center'}}>
                                                        {row.status
                                                            ?
                                                            <h6><span className="badge badge-success">Thành công</span>
                                                            </h6>
                                                            : <h6><span className="badge badge-danger">Lỗi</span></h6>
                                                            || 'Chưa có dữ liệu'}
                                                    </td>
                                                    <td className='p-1' style={{textAlign: 'center'}}>
                                                        <button
                                                            className="btn btn-action p-2"
                                                            disabled={row.status}
                                                            title="Gửi lại"
                                                            onClick={() => {
                                                                this.setState({itemSelected: row.id, showResend: true})
                                                            }}
                                                        >
                                                            <i className="ti-loop"/>
                                                        </button>
                                                        <button
                                                            className="btn btn-action p-2"
                                                            title="Xóa"
                                                            onClick={() => {
                                                                this.setState({itemSelected: row, showDelete: true})
                                                            }}
                                                        >
                                                            <i className="ti-trash"/>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>}
                                    </table>
                                </div>
                                <div className="pagination-right">
                                    <Pagination
                                        activePage={this.state.pageNumber + 1}
                                        itemsCountPerPage={this.state.pageSize}
                                        totalItemsCount={this.state.totalItem}
                                        changeHandler={(page) => this.handleChangePage(page)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.showDelete && <ModalDeleteEmail show={this.state.showDelete}
                                                            data={this.state.itemSelected}
                                                            onHide={() => this.setState({showDelete: false})}
                                                            onRefresh={() => this.getData()}
                />}

                {this.state.showResend && <ModalReSendEmail show={this.state.showResend}
                                                            data={this.state.itemSelected}
                                                            onHide={() => this.setState({showResend: false})}
                                                            onRefresh={() => this.getData()}
                />}
            </div>
        )
    }

}

export default ErrorEmailManagement
